/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RestartMode = 'connection' | 'application' | 'device';

export const RestartMode = {
    Connection: 'connection' as RestartMode,
    Application: 'application' as RestartMode,
    Device: 'device' as RestartMode
};

